export class uploadUrl {
    BATCH_URL = "org/v1/upload/batch";
    PROFORMA_URL = "org/v1/upload/proforma"
}